import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const LoadingRoute = () => (
  <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
    <CircularProgress aria-label="Cargando sesión" />
  </Box>
);

const AuthorizationPendingRoute = () => (
  <Box role="status" sx={{ p: 3 }}>
    No se pudo comprobar el acceso a esta página. Reintenta la comprobación de acceso para continuar.
  </Box>
);

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingRoute />;
  return isAuthenticated ? children : <Navigate to="/login" replace state={{ from: location }} />;
}

export function GuestRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <LoadingRoute />;
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
}

export function PermissionRoute({ permission, children }) {
  const { isAuthenticated, hasPermission, loading, permissionError } = useAuth();
  if (loading) return <LoadingRoute />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (permissionError) return <AuthorizationPendingRoute />;
  return hasPermission(permission) ? children : <Navigate to="/unauthorized" replace />;
}

export function AdminRoute({ children }) {
  const { isAuthenticated, loading, user, permissionError } = useAuth();
  if (loading) return <LoadingRoute />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (permissionError) return <AuthorizationPendingRoute />;
  return user?.rol === 'admin' ? children : <Navigate to="/unauthorized" replace />;
}
